import React, { Fragment } from 'react';

import { ClipboardIcon } from 'zoomforth_component_lib/app_modern_icons.jsx';

export default ()=> (
  <Fragment>
    Copied subpage to clipboard
  </Fragment>
);
